const en: Record<string, string> = {
  // ── Navbar ──
  'nav.home': 'Home',
  'nav.store': 'Store',
  'nav.about': 'About',
  'nav.news': 'News',
  'nav.contact': 'Contact',
  'nav.faq': 'FAQ',
  'nav.dashboard': 'Dashboard',
  'nav.settings': 'Settings',
  'nav.logout': 'Logout',
  'nav.login': 'Login',

  // ── Home ──
  'home.hero.title': 'Discover Your Realm.',
  'home.hero.subtitle': 'Embark on epic adventures in our premium Minecraft server featuring unique game modes, a thriving economy, and an amazing community.',
  'home.hero.joinNow': 'Join Now',
  'home.hero.visitStore': 'Visit Store',
  'home.hero.serverIp': 'Server IP:',
  'home.hero.copy': 'Copy',
  'home.hero.copied': 'Copied!',
  'home.hero.playersOnline': 'players online',

  'home.servers.title': 'Our Servers',
  'home.servers.subtitle': 'Choose your adventure from our carefully crafted game modes',

  'home.gameModes.kitpvp': 'KitPvP',
  'home.gameModes.kingdoms': 'Kingdoms',
  'home.gameModes.skyblock': 'Skyblock',
  'home.gameModes.boxpvp': 'BoxPvP',

  'home.features.customKits': 'Custom Kits',
  'home.features.rankedMatches': 'Ranked Matches',
  'home.features.tournaments': 'Tournaments',
  'home.features.nationWars': 'Nation Wars',
  'home.features.diplomacy': 'Diplomacy',
  'home.features.resourceControl': 'Resource Control',
  'home.features.islandLevels': 'Island Levels',
  'home.features.challenges': 'Challenges',
  'home.features.coopPlay': 'Co-op Play',
  'home.features.customArenas': 'Custom Arenas',
  'home.features.leaderboards': 'Leaderboards',
  'home.features.duels': '1v1 Duels',

  'home.news.title': 'Latest News',
  'home.news.subtitle': 'Stay updated with the latest server announcements and updates',
  'home.news.readMore': 'Read More',

  'home.howToJoin.title': 'How to Join',
  'home.howToJoin.subtitle': 'Get started in just a few simple steps',
  'home.howToJoin.step1.title': 'Get Minecraft',
  'home.howToJoin.step1.desc': 'Purchase and install Minecraft Java Edition from minecraft.net',
  'home.howToJoin.step2.title': 'Select Version',
  'home.howToJoin.step2.desc': 'Launch Minecraft 1.21+ for the best experience',
  'home.howToJoin.step3.title': 'Add Server',
  'home.howToJoin.step3.desc': 'Add play.silverclaw.eu to your server list',
  'home.howToJoin.step4.title': 'Register',
  'home.howToJoin.step4.desc': 'Use /register <password> in-game to create your account',

  'home.team.title': 'Meet Our Team',
  'home.team.subtitle': 'The dedicated people behind SilverClaw',
  'home.team.loading': 'Loading...',
  'home.team.empty': 'No staff members to display.',

  'home.discord.title': 'Join Our Discord',
  'home.discord.subtitle': 'Connect with thousands of players, get support, participate in events, and stay updated with the latest news!',
  'home.discord.members': 'Members',
  'home.discord.onlineNow': 'Online Now',
  'home.discord.join': 'Join Discord',

  // ── Store ──
  'store.title': 'Server Store',
  'store.subtitle': 'Unlock premium features, exclusive cosmetics, and special perks to enhance your gameplay',
  'store.yourBalance': 'Your Balance',
  'store.coins': 'Coins',
  'store.addCoins': 'Add Coins',
  'store.ranksTab': 'Ranks',
  'store.coinsTab': 'Coins',
  'store.serverRanks': 'Server Ranks',
  'store.serverRanksSubtitle': 'Choose a rank that fits your playstyle and unlock exclusive benefits',
  'store.features': 'Features',
  'store.select': 'Select',
  'store.alreadyInCart': 'Already in cart',
  'store.inCart': 'In cart',
  'store.coinPackages': 'Coin Packages',
  'store.coinPackagesSubtitle': 'Purchase coins to unlock ranks, cosmetics, and more',
  'store.bonus': '+{amount} Bonus',
  'store.purchase': 'Purchase',
  'store.bestValue': 'Best Value',
  'store.cart': 'Cart ({count})',
  'store.cartEmpty': 'Your cart is empty',
  'store.remove': 'Remove',
  'store.coinsLabel': 'Coins:',
  'store.realMoney': 'Real Money:',
  'store.checkout': 'Proceed to Checkout',
  'store.checkoutTitle': 'Checkout',
  'store.orderSummary': 'Order Summary',
  'store.qty': 'Qty:',
  'store.paymentDetails': 'Payment Details',
  'store.inGameCoins': 'In-Game Coins',
  'store.accountInfo': 'Account Information',
  'store.username': 'Username:',
  'store.currentBalance': 'Current Balance:',
  'store.billing': 'Billing:',
  'store.receipt': 'Receipt',
  'store.invoice': 'Invoice',
  'store.selectPayment': 'Select Payment Method',
  'store.payWithCoins': 'Pay with Coins',
  'store.useCoins': 'Use {amount} coins from your balance',
  'store.insufficientBalance': 'Insufficient balance ({balance} coins)',
  'store.cardPaypal': 'Credit / Debit Card',
  'store.paySecurely': 'Pay €{amount} securely via Tebex',
  'store.cancel': 'Cancel',
  'store.confirmPurchase': 'Confirm Purchase',
  'store.processing': 'Processing...',
  'store.chooseDuration': 'Choose how long you want to buy for',
  'store.month': '1 month',
  'store.months': '{months} months',
  'store.discount': '-{percent}%',
  'store.savings': 'Savings: {amount} coin',
  'store.perMonth': 'coin/mo',
  'store.rankContents': 'Rank contents:',
  'store.total': 'Total:',
  'store.addToCart': 'Add to cart',
  'store.loading': 'Loading...',
  'store.retry': 'Retry',
  'store.notEnoughCoins': 'Not enough coins',

  // ── FAQ ──
  'faq.title': 'Frequently Asked Questions',
  'faq.subtitle': 'Find answers to common questions about our server',
  'faq.search': 'Search for answers...',
  'faq.all': 'All',
  'faq.gettingStarted': 'Getting Started',
  'faq.storePayments': 'Store & Payments',
  'faq.accountSecurity': 'Account & Security',
  'faq.serverGameplay': 'Server & Gameplay',
  'faq.community': 'Community',
  'faq.noResults': 'No results found',
  'faq.noResultsHint': 'Try adjusting your search or browse all categories.',
  'faq.legal': 'Legal Information',
  'faq.legalSubtitle': 'Important policies and terms for using our services',
  'faq.tos': 'Terms of Service',
  'faq.tosDesc': 'Read our terms and conditions for using SilverClaw services.',
  'faq.privacy': 'Privacy Policy',
  'faq.privacyDesc': 'Learn how we collect, use, and protect your personal data.',
  'faq.needHelp': 'Still Need Help?',
  'faq.needHelpDesc': "Can't find what you're looking for? Our support team is here to assist you.",
  'faq.contactSupport': 'Contact Support',
  'faq.joinDiscord': 'Join Discord',
  'faq.loading': 'Loading FAQs...',

  // ── Contact ──
  'contact.title': 'Contact Us',
  'contact.subtitle': 'Have a question or need help? We\'re here for you!',
  'contact.emailTitle': 'Email Us',
  'contact.emailDesc': 'For general inquiries, partnerships, or business proposals:',
  'contact.supportTitle': 'Support',
  'contact.supportDesc': 'For technical support, account issues, or in-game problems:',
  'contact.hours': 'Support Hours',
  'contact.monFri': 'Monday - Friday',
  'contact.monFriHours': '9:00 AM - 6:00 PM EST',
  'contact.saturday': 'Saturday',
  'contact.saturdayHours': '10:00 AM - 4:00 PM EST',
  'contact.sunday': 'Sunday',
  'contact.sundayClosed': 'Closed',
  'contact.discordTitle': 'Discord',
  'contact.discordDesc': 'Join our Discord server for the fastest response times and community support.',
  'contact.followUs': 'Follow Us',
  'contact.formTitle': 'Send Us a Message',
  'contact.formSubtitle': 'Fill out the form below and we\'ll get back to you shortly.',
  'contact.name': 'Your Name',
  'contact.namePlaceholder': 'Enter your name',
  'contact.email': 'Email Address',
  'contact.emailPlaceholder': 'Enter your email',
  'contact.category': 'Category',
  'contact.selectCategory': 'Select a category',
  'contact.catGeneral': 'General Inquiry',
  'contact.catTechnical': 'Technical Support',
  'contact.catBilling': 'Billing Issue',
  'contact.catReport': 'Report a Player',
  'contact.catPartnership': 'Partnership',
  'contact.catOther': 'Other',
  'contact.subject': 'Subject',
  'contact.subjectPlaceholder': 'Brief subject',
  'contact.message': 'Message',
  'contact.messagePlaceholder': 'Tell us how we can help...',
  'contact.sending': 'Sending...',
  'contact.send': 'Send Message',
  'contact.successTitle': 'Message Sent!',
  'contact.successDesc': 'Thank you for reaching out. We\'ll get back to you as soon as possible, usually within 24-48 hours.',
  'contact.sendAnother': 'Send Another Message',
  'contact.faqTitle': 'Looking for Answers?',
  'contact.faqDesc': 'Check our frequently asked questions for quick answers to common inquiries.',
  'contact.viewFaq': 'View FAQ',

  // ── About ──
  'about.storyTitle': 'Our Story',
  'about.storySubtitle': 'From humble beginnings to one of the most beloved Minecraft communities, discover the journey that made SilverClaw what it is today.',
  'about.howStarted': 'How It All Started',
  'about.para1': 'SilverClaw began in 2020 as a small private server for friends who shared a passion for Minecraft. What started as a simple survival world quickly evolved into something much bigger as word spread about our unique approach to gameplay and community building.',
  'about.para2': 'Our founders believed that a Minecraft server should be more than just a place to play—it should be a home. A place where players from all walks of life can come together, make friends, and create lasting memories.',
  'about.para3': 'Today, SilverClaw stands as a testament to what can be achieved when passion meets dedication. With custom game modes, an active community, and constant innovation, we continue to push the boundaries of what a Minecraft server can be.',
  'about.quote': '"We didn\'t just want to create a server. We wanted to create a world where every player feels like they belong."',
  'about.quoteAuthor': '— DragonLord, Founder',
  'about.statPlayers': 'Registered Players',
  'about.statHours': 'Hours Played',
  'about.statDaily': 'Daily Players',
  'about.statUptime': 'Uptime',
  'about.valuesTitle': 'Our Values',
  'about.valuesSubtitle': 'The principles that guide everything we do',
  'about.value.community': 'Community First',
  'about.value.communityDesc': 'Our players are the heart of everything we do. We listen, adapt, and grow together.',
  'about.value.fairPlay': 'Fair Play',
  'about.value.fairPlayDesc': 'We maintain a balanced, cheat-free environment where skill and dedication are rewarded.',
  'about.value.innovation': 'Innovation',
  'about.value.innovationDesc': 'We constantly push boundaries with custom plugins, unique game modes, and fresh content.',
  'about.value.passion': 'Passion',
  'about.value.passionDesc': "We're gamers ourselves, driven by our love for Minecraft and creating memorable experiences.",
  'about.value.creativity': 'Creativity',
  'about.value.creativityDesc': 'We encourage players to express themselves through building, roleplay, and community events.',
  'about.value.trust': 'Trust',
  'about.value.trustDesc': 'Transparency and honesty guide every decision we make for our community.',
  'about.journeyTitle': 'Our Journey',
  'about.journeySubtitle': 'Key milestones in the SilverClaw story',
  'about.year.2020': 'The Beginning',
  'about.year.2020desc': 'SilverClaw was founded by a small group of passionate Minecraft players.',
  'about.year.2021': 'Growing Community',
  'about.year.2021desc': 'Reached 10,000 registered players and launched our first custom game mode.',
  'about.year.2022': 'Major Expansion',
  'about.year.2022desc': 'Introduced Skyblock, Kingdoms, and our premium rank system.',
  'about.year.2023': 'Global Recognition',
  'about.year.2023desc': 'Featured in top Minecraft server lists and grew to 50,000 players.',
  'about.year.2024': 'New Horizons',
  'about.year.2024desc': 'Launched custom mods, events system, and reached 100,000 registered players.',
  'about.year.2026': 'The Future',
  'about.year.2026desc': 'Continuing to innovate with new features and experiences for our community.',

  // ── Login ──
  'login.title': 'Welcome Back',
  'login.subtitle': 'Sign in with your Minecraft account',
  'login.username': 'Username',
  'login.usernamePlaceholder': 'Enter your Minecraft username',
  'login.password': 'Password',
  'login.passwordPlaceholder': 'Enter your password',
  'login.rememberMe': 'Remember me',
  'login.showPassword': 'Show password',
  'login.hidePassword': 'Hide password',
  'login.twoFactor': 'Two-Factor Authentication Code',
  'login.twoFactorPlaceholder': 'Enter 6-digit code from your authenticator app',
  'login.signingIn': 'Signing in...',
  'login.signIn': 'Sign In',
  'login.registerHint': "Don't have an account? Register in-game using /register <password> then use the same credentials here.",

  // ── Dashboard ──
  'dashboard.loading': 'Loading...',
  'dashboard.coins': 'Coins',
  'dashboard.playtime': 'Playtime',
  'dashboard.orders': 'Orders',
  'dashboard.totalSpent': 'Total Spent',
  'dashboard.guild': 'Guild',
  'dashboard.noGuild': 'No Guild',
  'dashboard.store': 'Store',
  'dashboard.settings': 'Settings',
  'dashboard.memberSince': 'Member since {date}',
  'dashboard.accountDetails': 'Account Details',
  'dashboard.username': 'Username',
  'dashboard.rankLuckPerms': 'Rank (LuckPerms)',
  'dashboard.rankGroup': 'Rank Group',
  'dashboard.lastLogin': 'Last Login',
  'dashboard.joined': 'Joined',
  'dashboard.recentPurchases': 'Recent Purchases',
  'dashboard.noPurchases': 'No purchases yet',
  'dashboard.quickLinks': 'Quick Links',

  // ── Settings ──
  'settings.backToDashboard': 'Back to Dashboard',
  'settings.title': 'Account Settings',
  'settings.subtitle': 'Manage your account settings and preferences',
  'settings.tabProfile': 'Profile',
  'settings.tabSecurity': 'Security',
  'settings.tabNotifications': 'Notifications',
  'settings.tabPreferences': 'Preferences',
  'settings.profileTitle': 'Profile Information',
  'settings.profileDesc': 'Your account is linked to your Minecraft username',
  'settings.billingTitle': 'Billing Preference',
  'settings.billingDesc': 'Choose whether you want to receive a receipt or an invoice for your purchases.',
  'settings.receipt': 'Receipt',
  'settings.receiptDesc': 'Simple purchase confirmation',
  'settings.invoice': 'Invoice',
  'settings.invoiceDesc': 'Detailed invoice with billing information',
  'settings.billingUpdated': 'Billing preference updated!',
  'settings.securityTitle': 'Security Settings',
  'settings.securityDesc': 'Your password is managed through Minecraft. Use /changepassword in-game to change it.',
  'settings.twoFactorTitle': 'Two-Factor Authentication',
  'settings.twoFactorDesc': 'Add an extra layer of security to your account using an authenticator app like Google Authenticator',
  'settings.twoFactorEnabled': 'Two-Factor Authentication is Enabled',
  'settings.disable2fa': 'Disable 2FA',
  'settings.currentPassword': 'Current Password',
  'settings.passwordPlaceholder': 'Enter your password',
  'settings.authCode': 'Authentication Code',
  'settings.authCodePlaceholder': 'Enter 6-digit code',
  'settings.confirmDisable': 'Confirm Disable',
  'settings.setup2fa': 'Setup Two-Factor Authentication',
  'settings.enterCode': 'Enter the 6-digit code from your authenticator app',
  'settings.verifying': 'Verifying...',
  'settings.enable2fa': 'Enable 2FA',
  'settings.twoFactorSuccess': 'Two-factor authentication enabled successfully!',
  'settings.notifTitle': 'Notification Preferences',
  'settings.notifSubtitle': 'Manage how you receive notifications',
  'settings.notifEmail': 'Email Notifications',
  'settings.notifEmailDesc': 'Receive updates about your purchases and account',
  'settings.notifPromo': 'Promotional Emails',
  'settings.notifPromoDesc': 'Get notified about special offers and discounts',
  'settings.notifNewsletter': 'Newsletter',
  'settings.notifNewsletterDesc': 'Weekly updates about server news and events',
  'settings.notifSecurity': 'Security Alerts',
  'settings.notifSecurityDesc': 'Get notified about login attempts and security events',
  'settings.savePreferences': 'Save Preferences',
  'settings.displayTitle': 'Display Preferences',
  'settings.displaySubtitle': 'Customize your experience',
  'settings.language': 'Language',
  'settings.theme': 'Theme',
  'settings.themeDark': 'Dark',
  'settings.themeLight': 'Light (Coming Soon)',
  'settings.dangerZone': 'Danger Zone',
  'settings.dangerDesc': 'Once you delete your account, there is no going back. Please be certain.',
  'settings.deleteAccount': 'Delete Account',

  // ── Blog ──
  'blog.title': 'News & Updates',
  'blog.subtitle': 'Stay updated with the latest server news, events, and community highlights',
  'blog.loading': 'Loading posts...',
  'blog.all': 'All Posts',
  'blog.updates': 'Updates',
  'blog.events': 'Events',
  'blog.community': 'Community',
  'blog.noPosts': 'No posts yet',
  'blog.noPostsHint': 'Check back later for updates!',
  'blog.search': 'Search posts...',
  'blog.categories': 'Categories',
  'blog.recentPosts': 'Recent Posts',
  'blog.tags': 'Tags',

  // ── NotFound ──
  'notFound.title': 'Page Not Found',
  'notFound.desc': "Oops! The page you're looking for doesn't exist or has been moved. Perhaps you took a wrong turn in the adventure?",
  'notFound.home': 'Return Home',
  'notFound.back': 'Go Back',
  'notFound.helpfulLinks': 'Here are some helpful links:',
  'notFound.store': 'Visit our Store',
  'notFound.faq': 'Check the FAQ',
  'notFound.support': 'Contact Support',

  // ── Payment Success ──
  'payment.processing': 'Processing Payment...',
  'payment.processingDesc': 'Please wait while we verify your payment.',
  'payment.success': 'Payment Successful!',
  'payment.successDesc': 'Thank you for your purchase. Your coins have been added to your account.',
  'payment.orderNumber': 'Order #:',
  'payment.continueShopping': 'Continue Shopping',
  'payment.goToDashboard': 'Go to Dashboard',
  'payment.failed': 'Payment Failed',
  'payment.failedDesc': 'An error occurred while processing your payment.',
  'payment.tryAgain': 'Try Again',
  'payment.contactSupport': 'Contact Support',

  // ── Footer ──
  'footer.desc': 'Embark on an epic journey in our premium Minecraft server. Discover unique game modes, join a thriving community, and create unforgettable adventures.',
  'footer.serverIp': 'Server IP:',
  'footer.quickLinks': 'Quick Links',
  'footer.gameModes': 'Game Modes',
  'footer.newsUpdates': 'News & Updates',
  'footer.community': 'Community',
  'footer.aboutUs': 'About Us',
  'footer.discord': 'Discord Server',
  'footer.ourTeam': 'Our Team',
  'footer.stayUpdated': 'Stay Updated',
  'footer.newsletter': 'Subscribe to our newsletter for the latest updates and exclusive offers.',
  'footer.emailPlaceholder': 'Enter your email',
  'footer.subscribe': 'Subscribe',
  'footer.payments': 'Accepted Payments',
  'footer.copyright': '© {year} SilverClaw. All rights reserved. Not affiliated with Mojang AB.',
  'footer.tos': 'Terms of Service',
  'footer.privacy': 'Privacy Policy',
  'footer.refund': 'Refund Policy',

  // ── Common ──
  'common.loading': 'Loading...',
  'common.error': 'An error occurred',
  'common.player': 'Player',
  'common.default': 'default',
};

export default en;
